// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { change } from 'redux-form'
import { Contact } from 'components/Form'

class DefaultContact extends React.Component {
  static propTypes = {
    change: func.isRequired,
    idRoot: string.isRequired,
    sourceForm: string.isRequired,
  }

  selectDefaultContact = ({ companyId, contactCode, contactId }) => {
    const {
      change,
      sourceForm,
    } = this.props

    // n is the input name
    // v is the value to assign to the input
    const c = (n, v) => change(sourceForm, n, v)
    c('defaultCompanyId', companyId)
    c('serviceContactCode', contactCode)
    c('defaultContactId', contactId)
  }

  // clears the currently assigned company
  clearDefaultContact = () => (
    this.selectDefaultContact({
      companyId: null,
      contactCode: '',
      contactId: null,
    })
  )

  render () {
    const {
      clearDefaultContact,
      selectDefaultContact,
    } = this

    const {
      idRoot,
      sourceForm,
    } = this.props

    return (
      <Contact
        clearable={clearDefaultContact}
        id={`${idRoot}default-contact`}
        label={'Default Contact'}
        name={'serviceContactCode'}
        selectRow={selectDefaultContact}
        sourceForm={sourceForm} />
    )
  }
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    change,
  }, dispatch)
)

export default connect(
  () => ({}),
  mapDispatchToProps
)(DefaultContact)
